import { HeaderProvider } from '@e3dc-react/shell/Libs/Header'
import { Box } from '@mui/material'
import React, { useState } from 'react'
import { UserData } from 'src/State/User/UserModel'
import { makeStyles } from 'tss-react/mui'
import Navigation from '../../Navigation/Navigation'
import HeaderWrapper from '../Header/HeaderWrapper'
import { useContentView } from '../hooks'
import useLinks from '../Links'
import ContentWrapper from './ContentWrapper'

const useStyles = makeStyles()(theme => {
  return {
    appContent: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      minWidth: 0,
    },
  }
})

interface Props {
  user?: UserData
  activeStorage?: string
  children?: React.ReactNode
}

/**
 * Delivers the content and it's surrounding navigation such as header, side and bottom bar
 */
const ContentView: React.FC<Props> = ({ children, user, activeStorage }) => {
  const links = useLinks()
  const [drawerOpen, setDrawerOpen] = useState(false)
  const handleDrawerOpenToggle = (): void => {
    setDrawerOpen(!drawerOpen)
  }
  const { classes } = useStyles()
  const [withTabs, setWithTabs] = useState<boolean>(false)
  const [headerHeight, setHeaderHeight] = useState<number>(0)
  const { isContentHeaderHidden, isNavigationHidden } = useContentView()

  return (
    <HeaderProvider>
      <Box sx={{ width: '100%' }} display={{ md: 'flex' }}>
        {!isNavigationHidden && <Navigation drawerOpen={drawerOpen} handleDrawerOpenToggle={handleDrawerOpenToggle} links={user ? links : []} />}
        <Box className={classes.appContent}>
          {!isContentHeaderHidden && (
            <HeaderWrapper
              activeStorage={activeStorage}
              handleDrawerOpenToggle={handleDrawerOpenToggle}
              setWithTabs={setWithTabs}
              setHeaderHeight={setHeaderHeight}
            />
          )}
          <ContentWrapper headerHeight={headerHeight} withTabs={withTabs}>
            {children}
          </ContentWrapper>
        </Box>
      </Box>
    </HeaderProvider>
  )
}

export default ContentView
